import React, { useState, useRef } from "react";
import { Button, Box, IconButton, TextField } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from "react-router-dom";
import './MediaUploadByParent.css'

const MediaUploadByParent = () => {
  const { docId, id, childId } = useParams();
  const navigate = useNavigate();
  const [audioSrc, setAudioSrc] = useState(null);
  const [videoSrc, setVideoSrc] = useState(null);
  const [audioComments, setAudioComments] = useState("")
  const [videoComments, setVideoComments] = useState("")

  const audioInputRef = useRef(null);
  const videoInputRef = useRef(null);

  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      if (type === "audio") {
        setAudioSrc(e.target.result);
      } else if (type === "video") {
        setVideoSrc(e.target.result);
      }
    };
    reader.readAsDataURL(file);
  };
  const removeFile = (type) => {
    if (type === "audio") {
      setAudioSrc(null);
      audioInputRef.current.value = ""; // Reset input
    } else if (type === "video") {
      setVideoSrc(null);
      videoInputRef.current.value = ""; // Reset input
    }
  };

  function handleSubmit(e) {
    e.preventDefault()
  }

  return (
    <div className="media-upload-container">
      <div className="headerContainer">
        <button
          className="backButton milestone-btn"
          onClick={() => navigate(`/parent-profile`)}
        >
          <FontAwesomeIcon className="icon" icon={faArrowLeft} />
          <span>Back to Child Profile</span>
        </button>
        <h1 className="heading">Media Uploads</h1>
      </div>

      <form onSubmit={handleSubmit} className="media-upload-innercontainer">
      {/* AUDIO UPLOAD */}
      <div className="media-container">
        <div className="media-input-container">
      <input
        type="file"
        accept="audio/*"
        ref={audioInputRef}
        onChange={(e) => handleFileChange(e, "audio")}
        style={{ display: "none" }}
      />
      <Button variant="contained" type="button" color="primary" onClick={() => audioInputRef.current.click()}>
        Choose Audio
      </Button>

      <TextField 
      type="text"
      size="small"
      name="audio_comments"
      label="Add Comments"
      value={audioComments}
      onChange={(e)=>setAudioComments(e.target.value)}
      sx={{width:'300px'}}
      />
      </div>
      {audioSrc && (
        <Box sx={{ mt: 2, display: "flex", alignItems: "center", justifyContent: "center",padding:"4px",backgroundColor:"#AFFFA0",borderRadius:'6px' }}>
          <audio controls>
            <source src={audioSrc} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <IconButton onClick={() => removeFile("audio")} color="error">
            <Delete />
          </IconButton>
        </Box>
      )}
   </div>

      {/* VIDEO UPLOAD */}
      <div className="media-container">
        <div className="media-input-container">
      <input
        type="file"
        accept="video/*"
        ref={videoInputRef}
        onChange={(e) => handleFileChange(e, "video")}
        style={{ display: "none" }}
      />
      <Button variant="contained" type="button" color="secondary" onClick={() => videoInputRef.current.click()}>
        Choose Video
      </Button>

      <TextField 
     type="text"
     size="small"
     name="video_comments"
     label="Add Comments"
     value={videoComments}
     onChange={(e)=>setVideoComments(e.target.value)}
     sx={{width:'300px'}}
     />
     </div>
      {videoSrc && (
        <Box sx={{ mt: 2, display: "flex", alignItems: "center", justifyContent: "center",padding:"4px",backgroundColor:"#AFFFA0",borderRadius:'6px' }}>
          <video controls width="300" height={'200'}>
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video element.
          </video>
          <IconButton onClick={() => removeFile("video")} color="error">
            <Delete />
          </IconButton>
        </Box>
      )}
      </div>
      <Button type="submit" variant="contained" color="success" sx={{width:150, marginTop:'20px'}}>Upload</Button>
      </form>
    </div>
  );
};
export default MediaUploadByParent;
